import React from "react";
import { Trash2 } from "lucide-react";

import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";

interface Props {
  open: boolean;
  handleClose: () => void;
  handleDelete: () => void;
}

export function BookingModal({ open, handleClose, handleDelete }: Props) {
  return (
    <Dialog open={open} onOpenChange={(state) => (!state ? handleClose() : null)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Excluir reserva</DialogTitle>
          <DialogDescription>
            Tem certeza que deseja excluir esta reserva? Esta ação não pode ser desfeita.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="destructive" onClick={handleDelete}>
            <Trash2 className="mr-2 h-4 w-4" /> Excluir
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
